import styled from 'styled-components';

const InfoRow = styled.div`
  margin-bottom: 19px;
`;

export default InfoRow;
